import { isEmpty, isEqual, isObject } from 'lodash'

import { forgeView } from '@/utils/forge-helpers/general'

const deepFreeze = (obj = {}) => {
  Object.freeze(obj)
  Object.values(obj).forEach(value => {
    if (isObject(value) && !Object.isFrozen(value)) {
      deepFreeze(value)
    }
  })
  return obj
}

const EMPTY_CONTEXT = Object.freeze({})

let cachedContext = EMPTY_CONTEXT

export const getForgeContext = async ({ fresh = false } = {}) => {
  if (!forgeView) return EMPTY_CONTEXT

  if (!fresh && !isEqual(cachedContext, EMPTY_CONTEXT)) return cachedContext

  const context = await forgeView.getContext()
  if (!context) return EMPTY_CONTEXT

  cachedContext = deepFreeze(context)
  return cachedContext
}

const NO_LOCATION = null

export const getForgeExtensionLocation = async ({ fresh = true } = {}) => {
  if (!forgeView) return NO_LOCATION

  const context = await getForgeContext({ fresh })

  if (!context || isEmpty(context)) return NO_LOCATION

  const { location = '' } = context?.extension || {}

  return location
}

export const getForgeConfluenceConfig = async () => {
  if (!forgeView) return null

  const context = await getForgeContext({ fresh: true })

  const { config = {} } = context?.extension || {}

  return config
}
